import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-services-on-link',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './services-on-link.component.html',
  styleUrl: './services-on-link.component.css'
})
export class ServicesOnLinkComponent {

}
